import { SerializableCriterion } from '../serializable-criterion';

export abstract class QuantitativeModifier extends SerializableCriterion {

  abstract isValid(): boolean;
}
